module.exports = __webpack_public_path__ + "static/media/expand-alt.39b9c4db.svg";